import React from "react";
import { Redirect } from "react-router";

import { CollectionDetailTopActionBar } from "./CollectionDetailTopActionBar";
import { CollectionDetailBottomActionBar } from "./CollectionDetailBottomActionBar";
import { CollectionDetailPageContent } from "./CollectionDetailPageContent";
import { ConfirmModal } from "../../Modals/ConfirmModal";
import { AlertModal } from "../../Modals/AlertModal";
import CompletedCollectionsIndexedDB from "../../../../CompletedCollectionsIndexedDB";
import APIService from "../../../../APIService";

const SUBMIT_CONFIRM_MESSAGE =
  "Once you have confirmed, you won't be able to edit this record";

export class CollectionDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      collection: {},
      is_loaded: false,
      updated_collection: {},
      isRecorded: false,
      showSubmitConfirm: false,
      alertMessage: "",
      submitError: null,
      isSubmitting: false,
    };
    if (!localStorage.getItem("driver")) {
      props.history.push({ pathname: "/driver" });
    }
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    if (CompletedCollectionsIndexedDB !== undefined) {
      this.completedCollectionsIndex = CompletedCollectionsIndexedDB;
      this.completedCollectionsIndex.createCompletedCollectionsIndexDB({
        objectStoreName: "collections",
        version: 3,
        onsuccess: this.createCompletedCollectionsSuccess.bind(this),
      });
    }
  }

  createCompletedCollectionsSuccess(event) {
    this.completedCollectionsIndex.db = event.target.result;
    this.setCollection();
  }

  openSubmitConfirm() {
    if (this.state.isRecorded) {
      this.setState({ alertMessage: this.getAlreadyRecordedMessage() });
      return;
    }
    this.setState({ showSubmitConfirm: true });
  }

  closeSubmitConfirm() {
    this.setState({ showSubmitConfirm: false });
  }

  closeAlert() {
    this.setState({ alertMessage: "" });
  }

  getErrorMessage(error, fallback) {
    return (error && error.message) || fallback;
  }

  getAlreadyRecordedMessage() {
    return this.getErrorMessage(
      this.state.submitError,
      "This collection has already been submitted."
    );
  }

  showAlreadyRecordedMessage() {
    this.setState({ alertMessage: this.getAlreadyRecordedMessage() });
  }

  async addCompletedCollection() {
    if (this.state.isSubmitting) {
      return;
    }

    // Remove any additonal items that are not completed
    var updated_collection = this.state.updated_collection;
    if (
      updated_collection.additional_collection_items !== undefined &&
      updated_collection.additional_collection_items.length > 0
    ) {
      var additional_items = [];
      updated_collection.additional_collection_items.forEach(
        (item, index, object) => {
          if (
            Object.keys(item.stock_item).length > 0 &&
            item.completed === true &&
            item.confirmed !== true
          ) {
            item.confirmed = true;
            additional_items.push(item);
          } else if (item.confirmed === true) {
            additional_items.push(item);
          }
        }
      );
      updated_collection.additional_collection_items = additional_items;
    }

    this.setState({ isSubmitting: true, showSubmitConfirm: false });

    try {
      await APIService.postCollection(
        updated_collection.unique_id,
        updated_collection
      );
      this.completedCollectionsIndex.updateCollectionInStore({
        data: updated_collection,
        onsuccess: this.addCompletedCollectionSuccess.bind(this),
      });
    } catch (error) {
      const locked = error.code === "COLLECTION_LOCKED";
      this.setState({
        isSubmitting: false,
        // Lock from Fusion: notify user and do not touch IndexedDB / local store.
        isRecorded: locked ? true : this.state.isRecorded,
        submitError: error,
        alertMessage: this.getErrorMessage(
          error,
          "Unable to submit this collection. Please try again."
        ),
      });
    }
  }

  addCompletedCollectionSuccess(event) {
    this.setState({ redirect: "/", isSubmitting: false, isRecorded: true });
  }

  getCompletedCollection(key) {
    this.completedCollectionsIndex.getCollectionInStore({
      key: key,
      onsuccess: this.getCompletedCollectionSuccess.bind(this),
    });
  }

  mergeExpectedQuantities(storedCollection, liveCollection) {
    if (!storedCollection || !liveCollection) {
      return storedCollection;
    }

    const liveItems = liveCollection.collection_items || [];
    const expectedById = {};
    liveItems.forEach((item) => {
      if (item && item.unique_id) {
        expectedById[item.unique_id] = {
          expected_collected: item.expected_collected,
          expected_delivered: item.expected_delivered,
        };
      }
    });

    return {
      ...storedCollection,
      collection_items: (storedCollection.collection_items || []).map(
        (item) => ({
          ...item,
          ...(expectedById[item.unique_id] || {}),
        })
      ),
    };
  }

  getCompletedCollectionSuccess(event) {
    const result = event.target.result;
    if (result && this.props.location.signatureRedirect === undefined) {
      const collection = this.mergeExpectedQuantities(
        result,
        this.props.location.collection
      );
      this.setState({
        collection: collection,
        is_loaded: true,
        updated_collection: collection,
        isRecorded: true,
      });
    } else {
      const collection = this.props.location.collection;
      this.setState({
        collection: collection,
        is_loaded: true,
        updated_collection: collection,
        isRecorded: collection && collection.status === "completed",
      });
    }
  }

  setCollection() {
    if (this.props.location.collection) {
      this.getCompletedCollection(this.props.location.collection.unique_id);
    } else {
      this.setState({
        redirect: "/",
      });
    }
  }

  setUpdatedCollection(collection) {
    this.setState({ updated_collection: collection });
  }

  render() {
    if (this.state.redirect) {
      return (
        <Redirect
          to={{
            pathname: this.state.redirect,
            collectionDay: this.props.location.collectionDay,
          }}
        />
      );
    } else {
      const collection = this.state.updated_collection;
      let collection_text = "";
      if (this.state.is_loaded === true) {
        let collection_date = new Date(collection.date);
        let day = collection_date.getDate();
        let month = collection_date.toLocaleString("default", {
          month: "short",
        });
        let year = collection_date.getFullYear();
        collection_text = `Collection ${day} ${month} ${year}`;
      }
      return (
        <>
          <CollectionDetailTopActionBar
            headerText={collection_text}
            labelButtonLeft=""
            displayButtonLeft={true}
            collectionDay={this.props.location.collectionDay}
            days={this.props.location.days}
          />
          <div id="collection-details" className="page-content">
            {this.state.is_loaded === true && (
              <CollectionDetailPageContent
                collection={collection}
                updateCollection={this.setUpdatedCollection.bind(this)}
                headerText={collection_text}
                isRecorded={this.state.isRecorded}
                onRecordedEditAttempt={this.showAlreadyRecordedMessage.bind(
                  this
                )}
              />
            )}
          </div>
          <CollectionDetailBottomActionBar
            labelButtonRight="Submit"
            displayButtonRight={true}
            onClickButtonRight={this.openSubmitConfirm.bind(this)}
          />
          <ConfirmModal
            show={this.state.showSubmitConfirm}
            message={SUBMIT_CONFIRM_MESSAGE}
            cancelLabel="Cancel"
            confirmLabel="Confirm"
            onCancel={this.closeSubmitConfirm.bind(this)}
            onConfirm={this.addCompletedCollection.bind(this)}
          />
          <AlertModal
            show={!!this.state.alertMessage}
            message={this.state.alertMessage}
            onClose={this.closeAlert.bind(this)}
          />
        </>
      );
    }
  }
}
